// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8230) return "static/chunks/8230-0a95e8a16623adab.js";
	if (chunkId === 184) return "static/chunks/184-f52909b516c0ac6a.js";
	if (chunkId === 774) return "static/chunks/774-02041f68cb7738ae.js";
	if (chunkId === 352) return "static/chunks/352-005735aa37435672.js";
	if (chunkId === 4060) return "static/chunks/4060-0dc9cd63f87a781d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"1022":"49073288","7144":"fa3de7d5","8233":"fcd35612"}[chunkId] || chunkId) + "." + {"1022":"140b0179d075d35a","2297":"263c139de0bc1b51","3788":"5171cb232cc7766a","4604":"23889072a4c16296","4751":"fffadac13df69832","7144":"059848be17a52f29","7746":"05582acfd85c80c0","8233":"39a5c3012f10df7a","9375":"831ec98cae3a300d","9591":"dc43708851f21443"}[chunkId] + ".js";
};